@for (message of getMessages(); track message) {
  <div class="message bg-success text-white p-1 mb-1"
    [ngClass]="{'bg-success':message.type==='success', 'bg-warning':message.type==='warning', 'bg-danger':message.type==='error', 'closing':message.closing}">
    <div class="d-flex align-items-center">
      <span class="flex-fill text-center">
        {{ message.message }}
        @if (hasData(message)) {
          <a class="btn btn-sm btn-primary dropdown-toggle" data-bs-toggle="collapse"
          aria-controls="snackbar-detail" href="#snackbar-detail" role="button" aria-expanded="false">Show details</a>
        }
      </span>
      @if (message.button) {
        <button type="button" class="btn btn-secondary btn-sm"
          (click)="close(message)">{{ message.button }}
        </button>
      }
    </div>
    <div class="collapse" id="snackbar-detail">
      <pre>{{ getData(message) }}</pre>
    </div>
  </div>
}
